import React from 'react';
import { propTypes } from '../../../util/types';
import { H2 } from '../../../components';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './SectionMooring.module.css';

const getMooringSpecs = (mooring, intl) => {
  const specs = [];

  if (mooring.marina) specs.push(mooring.marina);
  if (mooring.town) specs.push(mooring.town);
  if (mooring.mooringType) {
    const typeDisplay = mooring.mooringType.replace(/_/g, ' ').toLowerCase();
    specs.push(typeDisplay);
  }
  if (mooring.yearUntil)
    specs.push(`${intl.formatMessage({ id: 'Global.activeUntil' })} ${mooring.yearUntil}`);

  return specs.join(' • ');
};

const getMooringTypeDisplay = type => {
  if (!type) return '';
  return type
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, l => l.toUpperCase());
};

const formatMooringValue = (value, unit) => {
  if (value === undefined || value === null || value === '') return '';
  return unit ? `${value} ${unit}` : value.toString();
};

const SectionMooring = props => {
  const { mooring } = props;
  const intl = useIntl();

  if (!mooring) return null;

  const { title, mooringType, marina, town, maxBoatDraught, waterDepth, yearUntil } = mooring;

  return (
    <div className={css.root}>
      <H2 className={css.title} as="h2">
        <FormattedMessage id="ListingPage.mooringSubtitle" />
      </H2>

      <div className={css.content}>
        <div>
          {getMooringSpecs(mooring, intl) && <div>{getMooringSpecs(mooring, intl)}</div>}

          <div className={css.details}>
            {marina && (
              <div className={css.detail}>
                <span>{intl.formatMessage({ id: 'EditListingDetailsForm.marina' })}:</span>
                <span className={css.value}>{marina}</span>
              </div>
            )}
            {town && (
              <div className={css.detail}>
                <span>{intl.formatMessage({ id: 'EditListingDetailsForm.town' })}:</span>
                <span className={css.value}> {town}</span>
              </div>
            )}
            {mooringType && (
              <div className={css.detail}>
                <span>{intl.formatMessage({ id: 'EditListingDetailsForm.mooringType' })}:</span>
                <span className={css.value}>
                  {getMooringTypeDisplay(
                    intl.formatMessage({ id: `General.listing.type.mooring.${mooringType}` })
                  )}
                </span>
              </div>
            )}
            {yearUntil && (
              <div className={css.detail}>
                <span>{intl.formatMessage({ id: 'EditListingDetailsForm.yearUntil' })}:</span>
                <span className={css.value}>{yearUntil}</span>
              </div>
            )}
            {waterDepth && (
              <div className={css.detail}>
                <span>{intl.formatMessage({ id: 'EditListingDetailsForm.waterDepth' })}:</span>
                <span className={css.value}>{formatMooringValue(waterDepth, 'm')}</span>
              </div>
            )}
            {maxBoatDraught && (
              <div className={css.detail}>
                <span>{intl.formatMessage({ id: 'EditListingDetailsForm.maxBoatDraught' })}:</span>
                <span className={css.value}>{formatMooringValue(maxBoatDraught, 'm')}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

SectionMooring.propTypes = {
  mooring: propTypes.mooring,
};

export default SectionMooring;
